import { Checkbox } from "@components/forms/Checkbox";
import { createColumn } from "@/lib/table/columnFactory";
import type { Ticket } from "../types/ticket.types";

export const selectColumn = createColumn<Ticket>({
  id: "select",
  header: ({ table }) => (
    <Checkbox
      checked={table.getIsAllPageRowsSelected()}
      onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      aria-label="Sélectionner tout"
    />
  ),
  cell: ({ row }) => (
    <Checkbox
      checked={row.getIsSelected()}
      onCheckedChange={(value) => row.toggleSelected(!!value)}
      aria-label="Sélectionner la ligne"
    />
  ),
  enableSorting: false,
  enableHiding: false,
  size: 40,
});
